import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import EcoButton from 'eco-design/base/eco-button';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import useStatusCLang from '../../StatusC/useStatusCLang';
import ImgPreLoad from './ImgPreLoad';
import styled from './index.module.scss';
import FooterB from './FooterB';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const FooterA = () => {
    const { t } = useLang('theProduct.BannerA');
    return (
        <div className="banner-bottom">
            <p className="banner-bottom-desc">{t('desc2')}</p>
            <div>
                <EcoButton
                    lHref="#OnlineStoreRightsA3"
                    lType="filled"
                    lSize="extra-large"
                    lRadius="ellipse"
                    lBgColor="#3F68E0"
                    lDataLayer={{
                        event: 'uaEvent',
                        event_name: 'click_anchor',
                        position: 'Win an Exclusive EcoFlow STREAM Offer only on the EcoFlow official online store!',
                        button_name: 'Pre-Order Now',
                    }}
                    lChildren={t('btn1')}
                />
            </div>
        </div>
    );
};

export default function Comp() {
    const { t } = useStatusCLang('theProduct.BannerA');
    const { pageStatus } = useProductStore();
    const { locale = 'eu' } = useRouter();
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        theme: 'white',
        // heightType: 'full-screen',
        // isVideo: true,
        pc:
            locale === 'de'
                ? 'https://websiteoss.ecoflow.com/upload/image/1749471846051/de_KV.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1749461134345/en_KV.jpg',
        h5:
            locale === 'de'
                ? 'https://websiteoss.ecoflow.com/upload/image/1749464127495/1023-de-kv%20(1).jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1749464127287/1023-en-kv%20(1).jpg',
        label: pageStatus === IPageStatus.statusA ? t('label') : t('desc'),
        labelColor: '#fff',
        title: t('title'),
        subTitle: '',
        subTitleColor: '#FF7100',
        titleColor: '#fff',
        childrenB: pageStatus === IPageStatus.statusA ? <FooterA /> : <FooterB />,
        // poster: 'https://websiteoss.ecoflow.com/upload/image/1744944316617/steam-kv.jpg',
        // posterH5: 'https://websiteoss.ecoflow.com/upload/image/1744944487660/steam-kv-m.jpg',
    };
    return (
        <div id="banner" className={styled.banner}>
            <EcoBanner theme="black" {...dataA} />
            {/* <div className="footer-description">
                {t.rich('footer_desc', {
                    a: (text: any) => (
                        <a href={text} target="_blank">
                            {text}
                        </a>
                    ),
                })}
            </div> */}
            <ImgPreLoad />
        </div>
    );
}
